import CurrencyLocaleMapper from '@/constants/CurrencyLocaleMapper';

export function formatCurrency(num, currency) {
  let formatted = ' - ';
  try {
    if (num === null) {
      // Format with a symbol only if num is null
      formatted = new Intl.NumberFormat(
        CurrencyLocaleMapper[currency] || 'en-GB',
        {
          style: 'currency',
          currency: currency || 'GBP',
          minimumFractionDigits: 0,
          currencyDisplay: 'symbol',
        }
      ).format(0).replace(/\d/g, '').trim();
    } else {
      // Format normally if num is not null
      formatted = new Intl.NumberFormat(
        CurrencyLocaleMapper[currency] || 'en-GB',
        {
          style: 'currency',
          currency: currency || 'GBP',
          minimumFractionDigits: 0,
          currencyDisplay: 'symbol',
        }
      ).format(num);
    }
  } catch (e) {
    console.error(e);
  }
  return formatted;
}


export function formatSalaryText(salary) {
  if (salary?.min || salary.max)
    return `between ${formatCurrency(
      salary?.min,
      salary?.currency
    )} and ${formatCurrency(salary?.max, salary?.currency)}`;
  else return '-';
}

export function findClosest(needle, haystack) {
  var indexArr = haystack.map(function (k) {
    return Math.abs(k - needle);
  });
  var min = Math.min.apply(Math, indexArr);
  return haystack[indexArr.indexOf(min)];
}

export function roundSalary(num) {
  let round;
  if (num < 10) round = Math.round(num);
  else if (num < 100) round = Math.round(num / 10) * 10;
  else if (num < 1000) round = Math.round(num / 100) * 100;
  else round = Math.round(num / 1000) * 1000;
  return round;
}
